import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { createPermissionRequest } from '../api';

export default function useCreatePermissionRequest(userManagementCompanyId, useMutationOptions) {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: () => dispatch(createPermissionRequest({ userManagementCompanyId })),
    ...useMutationOptions,
  });
}
